export default "__VITE_ASSET__2UCVwnHa__"